import { WheelSnapshotV2Schema } from "@bridge-applications/pb-types";
import { z } from "zod";

export const WheelSliceSchema = z.object({
    refreshRequestedRevision: z.number().int().nonnegative().default(0),
    userId: z.uuid().nullable(),
    wheels: z.array(WheelSnapshotV2Schema),
    termsVersion: z.string().nullable(),
    status: z.enum(["idle", "loading", "ready", "error"]),
});
export type WheelSlice = z.infer<typeof WheelSliceSchema>;
